/* ============================================================
   FAQ App — simple accordion toggle via event delegation

   Single document-level click listener catches taps on any
   .pltx2-faqapp__q button (including clicks on its children
   like the SVG chevron). No per-button setup, no init timing
   issues, works for sections loaded after page load via
   shopify:section:load.

   Smooth open/close animation is 100% CSS via grid-template-rows
   trick — see pltx2-faq-app.css.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    // .closest() walks UP the DOM from the click target — so a click on the
    // chev span or the inner SVG still finds the parent button.
    var btn = e.target.closest && e.target.closest('.pltx2-faqapp__q');
    if (!btn) return;

    var item = btn.closest('.pltx2-faqapp__item');
    if (!item) return;

    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    var panel = document.getElementById(btn.getAttribute('aria-controls') || '');
    if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  });
})();
